import { UntypedFormGroup } from '@angular/forms';
import { Utilities } from 'src/app/services/utilities';

import { IVariable, Variable } from '../../models/interview-handler.models';
import { IFieldMetadata } from '../../models/template.models';
import { IFormatVariableOptions } from './../../models/interview-handler.models';
import { BaseVariableControl } from './_base-control';



export class DataGridControl extends BaseVariableControl {
    getVariableValue() {
        const currentValue = this.formControl.value;
        let result: any[] = [];
        const recordVariables = (this as any).fieldVariables as IVariable[];
        if (!recordVariables) {
            result = currentValue;
        } else {
            result = currentValue && (currentValue as any[]).map(record => {
                const recordResult = Utilities.cloneHard(record);
                recordVariables.forEach(fieldVariable => {
                    recordResult[fieldVariable.name] = fieldVariable.displayMetadata.formControl.getValue(record);
                });

                return recordResult;
            });
        }

        this.variable.value = result;
        return this.variable.value;
    }

    createReactiveControl(setValueChangedEvent: boolean = true) {

        this.addFormControl();

        if (setValueChangedEvent) {
            this.setOnChangeEvent(this.form.controls[this.variable.name]);
            this.variable.value = this.getVariableValue();
        }
    }

    getValue(item: any): any {
        const targetForm = this.fmBuilder.group({});
        const formFields = this.createFormFields(targetForm);
        const array: any[] = item ? [item] : (this.variable.value || []);

        const valueMapping = array.map(arrayItem => {
            const itemResult = { ...arrayItem };
            formFields.forEach(formField => {
                itemResult[formField.name] = formField.displayMetadata.formControl.getValue(arrayItem);
            });

            return itemResult;
        });

        formFields.forEach(field => field.displayMetadata.formControl.dispose());
        return item ? valueMapping[0] : valueMapping;
    }



    createFormFields(targetForm: UntypedFormGroup): IVariable[] {
        const fields = this.variable.displayMetadata.templateData.formFields as IFieldMetadata[];
        const formatOptions: IFormatVariableOptions = {
            formOptions: {
                targetForm
            }
        };

        return fields.map(field => {
            const variable = ({
                order: field.order,
                name: Utilities.camelize(field.propertyName),
                categoryName: null,
                display: true,
                displayMetadata: {
                    template: field.template,
                    templateData: field.templateData,
                },
                displayName: field.displayName
            } as IVariable);

            const variableItem = new Variable(variable);
            variableItem.format(this.handler, this.handler.variableStringParserService, formatOptions);
            return variableItem;
        });

    }

    getDisplayValue(item: any): any {
        let tempValue: any[] = null;
        if (item) {
            tempValue = item[Utilities.getVariableCaseInsensitive(item, this.variable.name)];
        } else {
            tempValue = this.variable.value;
        }

        if (tempValue) {
            return `List of ${tempValue.length} items`;
        } else {
            return 'N/A';
        }
    }
}
